import lfRequest from "@/service/index";

export function numStatistics() {
  return lfRequest.get<any>({
    url: '/home/numStatistics',
    params: {}
  })
}

export function empCallStatistics() {
  return lfRequest.get<any>({
    url: '/home/empCallStatistics',
    params: {}
  })
}

export function communicatePlan() {
  return lfRequest.get<any>({
    url: '/home/communicatePlan',
    params: {}
  })
}

export function columnChart(queryInfo: any) {
  return lfRequest.get<any>({
    url: '/home/columnChart',
    params: queryInfo
  })
}

// /home/ranking
export function ranking(queryInfo: any) {
  return lfRequest.get<any>({
    url: '/home/ranking',
    params: queryInfo
  })
}

// /home/myRanking
export function myRanking(queryInfo: any) {
  return lfRequest.get<any>({
    url: '/home/myRanking',
    params: queryInfo
  })
}

// /home/overview
export function overview(queryInfo: any) {
  return lfRequest.get<any>({
    url: '/home/overview',
    params: queryInfo
  })
}

// 组内数据详情
export function groupDetails(queryInfo: any) {
  return lfRequest.get<any>({
    url: '/home/groupDetails',
    params: queryInfo
  })
}
